import compact from "lodash/compact";

export const HEATMAP_MAX_RADIUS_COEFFICIENT = 0.1;
export const HEATMAP_DEFAULT_RADIUS = 40;
export const HEATMAP_DEFAULT_MAX_RADIUS = 100;
export const HEATMAP_MIN_RADIUS = 10;
export const HEATMAP_MIN_TRANSPARENCY = 0;
export const HEATMAP_MAX_TRANSPARENCY = 1;
export const HEATMAP_MIN_TRANSPARENCY_SLIDER = 0.1;
export const HEATMAP_TRANSPARENCY_COEFFICIENT = 100;
export const HEATMAP_MIN_TRANSPARENCY_MARK = 10;
export const HEATMAP_MAX_TRANSPARENCY_MARK = 100;
export const DEBOUNCE_DELAY_RADIUS_IN_MILESEC = 500;
export const PROJECTS_ROUTE = "heatmaps";

export const getRoute = (pages: (string | number)[] | (string | number)): string => {
  if (pages instanceof Array) {
    return `/${compact(pages).join("/")}`;
  }
  return `/${pages}`;
};
